import React from "react";
import Skeleton from "react-loading-skeleton";
import { styles } from "./styles";

interface SubSummaryRowProps {
  title: string;
  amount: string | number | null | undefined;
  currency: string;
  loading?: boolean;
  children?: React.ReactNode;
}

const SubSummaryRow: React.FC<SubSummaryRowProps> = ({
  title,
  amount,
  currency,
  loading = false,
  children
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.spacer} />
        {title}
        {children}
      </div>

      {loading ? (
        <Skeleton width={100} height="100%" />
      ) : (
        <div className={styles.right}>
          <div className={styles.amount}>{amount}</div>
          <div className={styles.currency}>{currency}</div>
        </div>
      )}
    </div>
  );
};

export default SubSummaryRow;
